/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The status of the rate validation. 'pending' means the rate validation is still in progress. 'rate_not_found' means the rate could not be found. 'request_failure' means there was an error processing the request. 'success' means the rate validation was successful.
 * @export
 */
export const RateValidationStatus = {
    Pending: 'pending',
    RateNotFound: 'rate_not_found',
    RequestFailure: 'request_failure',
    Success: 'success'
} as const;
export type RateValidationStatus = typeof RateValidationStatus[keyof typeof RateValidationStatus];


export function instanceOfRateValidationStatus(value: any): boolean {
    for (const key in RateValidationStatus) {
        if (Object.prototype.hasOwnProperty.call(RateValidationStatus, key)) {
            if (RateValidationStatus[key as keyof typeof RateValidationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RateValidationStatusFromJSON(json: any): RateValidationStatus {
    return RateValidationStatusFromJSONTyped(json, false);
}

export function RateValidationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateValidationStatus {
    return json as RateValidationStatus;
}

export function RateValidationStatusToJSON(value?: RateValidationStatus | null): any {
    return value as any;
}

export function RateValidationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): RateValidationStatus {
    return value as RateValidationStatus;
}

